import React, { useEffect } from "react";
import "../../messaging/inbox/inbox.css"
import { MessageItem } from "../../../../../dataModel/messagesModal";
import mailReply from "../../../../../images/mailreply.png"
import moment from "moment";
import { messages } from "../../../../../services/messageService";
import { useDispatch } from "react-redux";
import { markMessageAsRead } from "../../../../../redux/actions";

export interface MessageViewProps {
    onClose(): void,
    message: MessageItem | any,
    isInbox:number,
    onReplyMessage():void
}

const ViewMessage = (props: MessageViewProps) => {
    const messageData: MessageItem = props.message
     const dispatch=useDispatch()
    const openAttachment = (attachmentId:string) => {
        // setLoading(true);
        messages.getAttachment(attachmentId).then((result:any)=>{
            var url = result?.resultData?.url;
            window.open(url, '_blank')?.focus();
        })
    
    }
    useEffect(()=>{
        if(props.isInbox===0){
            dispatch(markMessageAsRead({
                "messageReceiverId": [
                    props.message.messageReceiverId
                ]
              }))
        }
    },[props.isInbox])
    return (
        <>
            <section className="message-wrapper">
                <div className="container-fluid">
                    <div className="viewConversation mb-3">
                        <div className="bg-white p-4 h-100 border20">
                            <div className="d-flex align-items-center flex-wrap m-4 justify-content-between mb-3">
                                <div className="d-flex align-items-start">
                                    <button onClick={() => {
                                        props.onClose()
                                    }}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 16 30" fill="none">
                                            <path d="M0.424759 13.5327C-0.141586 14.099 -0.141586 15.0452 0.424759 15.613L13.4923 28.7141C14.066 29.2877 14.9962 29.2877 15.5683 28.7141C16.1419 28.1405 16.1419 27.2088 15.5683 26.6352L3.53882 14.5722L15.5698 2.51057C16.1434 1.93551 16.1434 1.00527 15.5698 0.430212C14.9962 -0.143396 14.066 -0.143396 13.4938 0.430212L0.424759 13.5327Z" fill="black" />
                                        </svg></button>
                                    <h2 className="ml-3 mb-0">View Conversation</h2>
                                </div>
                              {(props.isInbox<2) &&  <button className="message-reply btn blue-primary text-white d-flex" onClick={()=>{props.onReplyMessage()}}>
                              <img src={mailReply} alt="mainReply" className="iconBtn" /> Reply
                                </button>}
                            </div>

                            <h2 className="my-2 mb-3">{messageData.subject}</h2>

                            <div className="message-editor">
                                 {messageData?.htmlBody && <RawHTML>{messageData.htmlBody}</RawHTML>}


                                {
                                    messageData?.attachments.map((attachment)=><button onClick={()=>openAttachment(attachment.attachmentId)} className={ "upload-attachemnt mt-2 mb-1 "}> 
                                   
                                    {attachment.fileName}
                                    </button>)
                                }

                                <div className="sender">
                                    <p>{
                                    props.isInbox==0?
                                    `Sent by ${messageData.fromStaffName} on ${moment.utc(messageData.utcDateCreated).local().format('M/D/YYYY, hh:mm A')}`:
                                    `Sent to ${messageData.toStaffName} on ${moment.utc(messageData.utcDateCreated).local().format('M/D/YYYY, hh:mm A')}`}</p>
                                </div>


                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
        </>
    )
}

export default ViewMessage;



   export const RawHTML: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => {
        const processHtml = (html: any) => {
            if (!html) return "";

            html = html.replace(/\n/g, "<br />");

            html = html.replace(
                /(^|\s)(www\.[^\s<]+)/gi,
                '$1<a href="https://$2" target="_blank" rel="noopener noreferrer">$2</a>'
            );

            html = html.replace(
                /(^|\s)(https?:\/\/[^\s<]+)/gi,
                '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>'
            );

            html = html.replace(
                /href="(?!https?:\/\/|mailto:|tel:|ftp:)([^"]+)"/gi,
                'href="https://$1"'
            );

            return html;
        };

        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{ __html: processHtml(children) }}
            />
        );
    };